import { InputLabel, Select as MuiSelect, styled } from '@mui/material';
import type { FormItemUiDefinition } from 'types/formItem';

export const Wrapper = styled('div')(() => ({ width: '100%' }));

export const StyledSelect = styled(MuiSelect, {
  shouldForwardProp: (prop) =>
    prop !== 'uiDefinitionStyles' && prop !== 'background' && prop !== 'error' && prop !== 'lightError' && prop !== 'formItemUiDefinition',
})<{
  background?: 'transparent' | 'white';
  error?: boolean;
  lightError?: boolean;
  formItemUiDefinition?: FormItemUiDefinition;
}>(({ theme, background = 'transparent', error, lightError, formItemUiDefinition }) => ({
  ...(formItemUiDefinition?.attributeColor && {
    backgroundColor: formItemUiDefinition.attributeColor,
  }),

  ...(formItemUiDefinition?.columnBorderColor && {
    border: `1px ${formItemUiDefinition.columnBorderColor} solid`,
  }),

  minWidth: 0,
  '& .MuiSelect-outlined': {
    backgroundColor: error && !lightError ? theme.palette.error.light : background === 'transparent' ? 'transparent' : theme.palette.common.white,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: error || lightError ? theme.palette.error.main : undefined,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: error || lightError ? theme.palette.error.main : undefined,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: error || lightError ? theme.palette.error.main : undefined,
  },
  '& svg': {
    width: '20px',
  },

  ...(formItemUiDefinition?.textStyle?.color && {
    '& .MuiSelect-select.Mui-disabled': {
      color: formItemUiDefinition.textStyle.color,
      WebkitTextFillColor: formItemUiDefinition.textStyle.color,
    },
  }),
}));

export const StyledLabel = styled(InputLabel)({
  whiteSpace: 'wrap',
});
